import { Box } from '@mui/material'
import { useStoreState } from '../../../store/hooks'
import { ChallengeCard } from '../components'
import { Loader } from '../components/rewards/Loader'
import { WeeklyCountdown } from '../components/rewards/WeeklyCountdown'

export const RewardsChallenges = () => {
    const { challenges, loadingSummary } = useStoreState((state) => state.rewardsService)

    const isLoading = challenges === undefined && loadingSummary

    return (
        <Box
            display="flex"
            flexDirection="column"
            gap={1.5}
            width="100%"
            sx={{ overflowY: 'auto', overflowX: 'hidden' }}
        >
            {isLoading ? (
                <Loader />
            ) : challenges?.length ? (
                challenges.map((item) => <ChallengeCard key={item.title} {...item} />)
            ) : (
                <Box display="flex" justifyContent="center" alignItems="center" height="100%">
                    <WeeklyCountdown />
                </Box>
            )}
        </Box>
    )
}
